import styles from './index.module.scss'
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState, useContext } from 'react'
import eventBus from "@utils/eventBus";
import { Button, Dropdown, Slider, Space, Switch, message, Segmented, Popover } from "antd"
import Iconfont from '@utils/Iconfont';
import { useNavigate } from "react-router";
import PSAIModal from '@PSAIComponents/PSAIModal';
import { GENERATE_MODE, BATCH_IMAGES_TYPE, RELIGHT_MODE, UPLOAD_SOURCE, RESOLUTION_ALIGN, MODEL_EXPRESSION } from "@utils/CONST"
import Utils from '@utils/utils';
import API from "@api/api";
import { BatchImagesContext } from "../BatchImagesContext"
import { QuestionCircleOutlined } from '@ant-design/icons';
const BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/'

const modeItems = [{
    value: GENERATE_MODE.STD,
    title: "标准模式",
    content: "生成速度更快",
    icon: <Iconfont type="icon-stdOutlined" />,
    iconActive: <Iconfont type="icon-stdFilled" />,
}, {
    value: GENERATE_MODE.HQ,
    title: "高品质模式",
    content: "生成效果更好",
    icon: <Iconfont type="icon-hdOutlined" />,
    iconActive: <Iconfont type="icon-hdFilled" />,
    // isLimit: true,
}]

const resolutionAlignItems = [{
    value: RESOLUTION_ALIGN.INPUT,
    title: "上传图比例",
    content: "按上传图比例生成",
}, {
    value: RESOLUTION_ALIGN.BKG,
    title: "参考图比例",
    content: "按已选背景参考图比例",
}]

const FooterBar = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        handleBatchExit
    }))
    const { setIsBatchAppendSmartPage } = useContext(BatchImagesContext)
    const navigate = useNavigate()
    const {
        projectType,
        uploading,
        selectedRowKeys,
        selectedRows,
        onAddMore,
        skuNumber,
        projectId,
        isEdit,
        dataSource,
        setDataSource
    } = props
    const [batchMode, setBatchMode] = useState()
    const [submitConfigVisible, setSubmitConfigVisible] = useState(false)
    const [handleNumber, setHandleNumber] = useState(4)
    const [generateMode, setGenerateMode] = useState(GENERATE_MODE.STD)
    const [resolutionAlign, setResolutionAlign] = useState(RESOLUTION_ALIGN.INPUT)
    const [switchChecked, setSwitchChecked] = useState(false)
    const [switchChecked2, setSwitchChecked2] = useState(false)
    const [relight, setRelight] = useState(0.0)
    const [loading, setLoading] = useState(false)
    const [createLoading, setCreateLoading] = useState(false)
    const [total, setTotal] = useState(0)
    const [relightMode, setRelightMode] = useState(projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? RELIGHT_MODE.PORTRAIT : RELIGHT_MODE.SKIN)
    const [emoji, setEmoji] = useState(MODEL_EXPRESSION.SRC)

    useEffect(() => {
        if (projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
            setHandleNumber(1)
        }
        setRelightMode(projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? RELIGHT_MODE.PORTRAIT : RELIGHT_MODE.SKIN)
    }, [projectType])

    const handleBatchClick = ({ key }) => {
        console.log('key', key)
        setBatchMode(key)
        props.getBatchMode(key)
        props.setShowSelectionColumn(true)
    }
    const handleBatchExit = () => {
        setBatchMode()
        setIsBatchAppendSmartPage(false)
        props.setShowSelectionColumn(false)
        props.setSelectedRowKeys([])
        props.setSelectedRows([])
    }

    // 暴露handleBatchExit方法给父组件
    useImperativeHandle(ref, () => ({
        handleBatchExit
    }))

    const handleBatchSubmit = async () => {
        if (batchMode == 'appendTop' || batchMode == 'appendBottom') {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/jpeg,image/png,image/webp,image/avif';
            input.onchange = async (e) => {
                try {
                    let file = e.target.files[0];
                    if (file) {
                        setLoading(true)
                        // 检查文件类型和宽高比
                        const isNromal = await Utils.validateImageFile(file)
                        if (!isNromal) return
                        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
                        if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message) }
                        file = resizeRes.file
                        const legalRes = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.SERVICE)
                        if (!legalRes || !legalRes.isLegal) { message.warning(legalRes?.message); return; }

                        // 检测上传图类型
                        const clothType = await API.getClothType({ imageUrl: legalRes?.data })
                        const clothTextList = ['上装', '下装', null, '裙装']
                        if ((clothType?.data === 0 && batchMode == 'appendTop') || (clothType?.data === 1 && batchMode == 'appendBottom')) {
                            saveUploadImg(legalRes.data)
                        } else {
                            PSAIModal.confirm({
                                title: `系统检测到您上传的图片可能是${clothTextList[clothType.data]}`,
                                okText: "继续填入",
                                cancelText: `取消上传`,
                                onOk() {
                                    saveUploadImg(legalRes.data)
                                },
                                onCancel() {
                                    setLoading(false)
                                }
                            })
                        }
                    }
                } catch (error) {
                    setLoading(false)
                }
            }
            input.click();
        } else if (batchMode == 'appendCSimRecolorInput' || batchMode == 'appendCSimRecolorMatch') {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/jpeg,image/png,image/webp,image/avif';
            input.onchange = async (e) => {
                try {
                    let file = e.target.files[0];
                    if (file) {
                        setLoading(true)
                        const isNromal = await Utils.validateImageFile(file)
                        if (!isNromal) return
                        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
                        if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message) }
                        file = resizeRes.file
                        const legalRes = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.SERVICE)
                        if (!legalRes || !legalRes.isLegal) { message.warning(legalRes?.message); return; }
                        if (batchMode == 'appendCSimRecolorInput') {
                            setDataSource(prev => prev.map(item => {
                                if (selectedRowKeys.includes(item.skuId)) {
                                    return {
                                        ...item,
                                        inputCloth: legalRes.data,
                                    }
                                }
                                return item
                            }))
                        } else {
                            setDataSource(prev => prev.map(item => {
                                if (selectedRowKeys.includes(item.skuId)) {
                                    return {
                                        ...item,
                                        matchCloth: legalRes.data,
                                    }
                                }
                                return item
                            }))
                        }
                        setLoading(false)
                        handleBatchExit()
                    }
                } catch (error) {
                    setLoading(false)
                }
            }
            input.click();
        } else if (batchMode == 'appendCustomBkg') {
            let customBkgMode = 'free'
            PSAIModal.confirm({
                title: <>
                    <p style={{ marginBottom: 12 }}>批量设置场景相似度</p>
                    <Segmented
                        options={[
                            { label: '变化更多', value: 'free' },
                            { label: '场景不变', value: 'sim' }
                        ]}
                        onChange={(value) => {
                            customBkgMode = value
                        }}
                    />
                </>,
                okText: "确认",
                cancelText: `取消`,
                onOk() {
                    setDataSource(prev => prev.map(item => {
                        if (selectedRowKeys.includes(item.skuId)) {
                            return {
                                ...item,
                                customBkgMode: customBkgMode,
                            }
                        }
                        return item
                    }))
                    handleBatchExit()
                },
                onCancel() {
                    setLoading(false)
                }
            })
        } else if (batchMode == 'appendModel') {
            props.openReferenceDrawer(
                [], (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH || projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) ?
                1 : 10, {}, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)
        } else if (batchMode == 'appendBkg') {
            props.openReferenceDrawer([], 10, {}, BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH)
        } else if (batchMode == 'appendTryon') {
            props.openReferenceDrawer([], 10, {}, BATCH_IMAGES_TYPE.TRYON_BATCH)
        } else if (batchMode == 'appendCommodityStacking') {
            props.openReferenceDrawer([], 10, {}, BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH)
        } else if (batchMode == 'delete') {
            props.handleRemove(selectedRows.map(item => item.skuId))
        } else if (batchMode == 'appendCategory') {
            setIsBatchAppendSmartPage(true)
            props.handleAppendCategory(selectedRows.map(item => item.skuId))
        } else if (batchMode == 'appendTemplate') {
            setIsBatchAppendSmartPage(true)
            props.handleAppendTemplate(selectedRows.map(item => item.skuId))
        }
    }
    const saveUploadImg = async (url) => {
        const updatedRows = selectedRows.map(item => {
            const newInputImages = [...item.inputImages];
            const nonMainIndex = newInputImages.findIndex(img => img.mainImage === false);

            if (nonMainIndex !== -1) {
                newInputImages[nonMainIndex] = {
                    ...newInputImages[nonMainIndex],
                    url,
                };
            } else {
                newInputImages.push({
                    mainImage: false,
                    url,
                });
            }

            return {
                ...item,
                projectId,
                inputImages: newInputImages,
            };
        });

        console.log("更新后的 selectedRows:", updatedRows);
        const saveRes = await API.batchSaveSku(updatedRows)
        if (saveRes?.code === 0) {
            props.listSkuByProject()
            handleBatchExit()
            setLoading(false)
        }
    };

    // 批量操作
    const items = useMemo(() => {
        if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH) {
            return [
                { key: "appendTop", label: "批量添加上装" },
                { key: "appendBottom", label: "批量添加下装" },
                { key: "appendModel", label: "设置模特图" },
                { key: "appendTryon", label: "设置模试衣参考图" },
                { key: "delete", label: "批量删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH || projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
            return [
                { key: "appendModel", label: "设置模特图" },
                { key: "delete", label: "批量删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) {
            return [
                { key: "appendCustomBkg", label: "设置场景相似度" },
                { key: "appendBkg", label: "设置背景图" },
                { key: "delete", label: "批量删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
            return [
                { key: "appendCommodityStacking", label: "设置辅品图" },
                { key: "delete", label: "批量删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH) {
            return [
                { key: "appendCSimRecolorInput", label: "设置同款不同色平铺图" },
                { key: "appendCSimRecolorMatch", label: "设置搭配图" },
                { key: "delete", label: "批量删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH || projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) {
            return [
                { key: "delete", label: "批量删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
            return [
                { key: "appendCategory", label: "设置类目" },
                { key: "appendTemplate", label: "选择模板" },
                { key: "delete", label: "批量删除" },
            ]
        }
    }, [projectType])


    const handleSubmitConfig = async () => {
        if (dataSource.length === 0) {
            message.error('请先添加商品')
            return
        }
        setCreateLoading(true)

        // 检测未选参考图的sku
        const processedDataSource = dataSource.map(item => {
            // 创建新对象以避免直接修改原始数据
            const newItem = { ...item };

            // 根据projectType检查对应的数组长度
            if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH && (!item.refList || item.refList.length === 0)) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH && (!item.modelList || item.modelList.length === 0)) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && (!item.bkgList || item.bkgList.length === 0)) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH && !item.inputCloth) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH && item.inputImages.length < 10) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH && (!item.commodityColor || !item.commodityCategory || !item.commodityTemplate)) {
                newItem.error2 = true;
            } else {
                newItem.error = false;
                newItem.error2 = false;
            }
            return newItem;
        })
        setDataSource(processedDataSource)

        // 检查是否有任何项设置了error = true
        const hasErrorItems = processedDataSource.some(item => item.error === true);
        // 检查是否有任何项设置了error2 = true
        const hasError2Items = processedDataSource.some(item => item.error2 === true);
        if (hasError2Items) {
            setCreateLoading(false);
            setSubmitConfigVisible(false)
            message.error('请填写完整商品颜色、类目、模板！');
            return;
        }

        if (hasErrorItems) {
            setCreateLoading(false)
            setSubmitConfigVisible(false)
            if (projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
                message.error('每组详情页至少上传10张详情页图，请检查并补充完整！')
            } else {
                message.error('存在必填信息缺失的项，请先填写完整！')
            }
            return;
        }

        // 重新编辑发起
        if (isEdit) {
            editAndGenerate()
            return
        }

        const startRes = await API.batchStartProject({
            projectId: projectId,
            num: projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? 1 : handleNumber,
            mode: generateMode,
            relightMode: relightMode,
            emoji: emoji,
            resolutionAlign: resolutionAlign,
            skinRefine: switchChecked ? 1 : 0,
            relight: relight,
        })
        setCreateLoading(false)
        if (startRes?.code === 0) {
            sessionStorage.removeItem('batchProductImagesPageIndex')
            message.success('项目发起成功')
            setSubmitConfigVisible(false)
            navigate(`/home/product/${projectId}/detail`)
        } else if (startRes?.code === -5012) {
            message.error('虹豆不足，请先购买会员')
            eventBus.emit('recharge')
        } else {
            message.error(startRes?.message)
        }
    }

    const editAndGenerate = async () => {
        const startRes = await API.editAndGenerate({
            ...dataSource[0],
            num: projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? 1 : handleNumber,
            mode: generateMode,
            relightMode: relightMode,
            emoji: emoji,
            resolutionAlign: resolutionAlign,
            skinRefine: switchChecked ? 1 : 0,
            relight: relight,
            projectId
        })
        if (startRes?.code === 0) {
            navigate(`/home/product/${projectId}/detail`)
        } else {
            message.error(startRes?.message)
        }
    }

    useEffect(() => {
        if (!dataSource || dataSource.length === 0) return;

        const totalLength = dataSource.reduce((sum, item) => {
            const bkgCount = item?.bkgList?.length || 0;
            const modelCount = projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? 0 : item?.modelList?.length;
            const refCount = item?.refList?.length || 0;
            return sum + bkgCount + modelCount + refCount;
        }, 0);

        setTotal(totalLength)
    }, [dataSource]);

    const Text1 = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '试衣参考图' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH || projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '模特参考图' :
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '背景参考图' :
                    projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '辅品图' :
                        ''
    }, [projectType])
    const Text2 = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '添加商品图' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH || projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '添加模特图' :
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '添加模特图' :
                    projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '添加主品图' :
                        projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? '添加详情页组合' :
                            '添加输入图'
    }, [projectType])
    const Text3 = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? ' 个商品' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH || projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? ' 个模特' :
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? ' 个模特' :
                    projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? ' 个主品' :
                        projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? ' 个详情页组合' :
                            projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? ' 张源素材' :
                                projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? ' 组穿搭' :
                                    '张输入图'
    }, [projectType])

    const costInfo = useMemo(() => {
        let cost = 0;
        let desc = '';
        const len = dataSource?.length || 0;

        switch (projectType) {
            case BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH:
                cost = len * 40;
                desc = '商品组合（主品）数 *40 虹豆';
                break;
            case BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH:
                cost = len * handleNumber * 5;
                desc = `源素材${len}张*每张素材图生成${handleNumber}张* 5虹豆`;
                break;
            case BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH:
                cost = len * handleNumber * 10;
                desc = `模特图${len}张*每张模特图生成${handleNumber}张* 10虹豆`;
                break;
            case BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH:
                cost = len * handleNumber * 10;
                desc = `输入图${len}张*每张模特图生成${handleNumber}张* 10虹豆`;
                break;
            case BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH:
                cost = len * handleNumber * 1000;
                desc = `详情页${len}组*每组详情页生成${handleNumber}组* 1000虹豆`;
                break;
            case BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH:
                cost = len * handleNumber * 10;
                desc = `每张源素材生成${handleNumber}张* 10虹豆`;
                break;
            case BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH:
                cost = total * handleNumber * 10;
                desc = `背景参考图${total}张*每张参考图生成${handleNumber}张*${10}虹豆`;
                break;
            default:
                const price = generateMode === GENERATE_MODE.STD ? 10 : 15;
                cost = total * handleNumber * price;
                desc = `试衣参考图${total}张*每张参考图生成${handleNumber}张*${price}虹豆`;
        }
        return { cost, desc }
    }, [projectType, dataSource, handleNumber, total, generateMode])

    const relightModeItems = [{
        text: '标准模式',
        value: projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? RELIGHT_MODE.PORTRAIT : RELIGHT_MODE.SKIN,
    }, {
        text: '反光板模式',
        value: RELIGHT_MODE.REFLECTOR,
    }]

    const emojiList = [{
        text: '按原图',
        value: MODEL_EXPRESSION.SRC,
    }, {
        text: '按参考图',
        value: MODEL_EXPRESSION.REF,
    }]

    const contentList = [{
        url: '1.png',
        title: '标准模式',
        smallTitle: '使人物与环境的光影和谐一致',
    }, {
        url: '2.png',
        title: '标准模式',
        smallTitle: '使人脸与身体的光影和谐一致',
    }, {
        url: '3.png',
        title: '反光板模式',
        smallTitle: '使人脸光影更柔和，降低对比度',
    }].filter(item => {
        if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && item.url === '2.png') return false
        else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH && item.url === '1.png') return false
        return true
    })

    const ContentBox = (
        <div className={styles.ContentBox}>
            {
                contentList.map((item) => (
                    <div key={item.value} className={styles.ContentItem}>
                        <img src={BASE_URL + item.url} alt={item.title} />
                        <div className={styles.title}>{item.title}</div>
                        <div className={styles.smallTitle}>{item.smallTitle}</div>
                    </div>
                ))
            }
        </div>
    )

    return (
        <div className={styles.FooterBar}>
            {
                uploading ?
                    <>
                        <div className={styles.FooterBarLeft}>
                            <Button disabled className={styles.BatchTrigger}>批量操作</Button>
                        </div>
                        <div className={styles.FooterBarRight}>
                            <div className={styles.BtnGroup}>
                                <Button style={{ width: 200, height: 36 }} disabled={true}>添加源素材</Button>
                                <Button style={{ width: 200, height: 36 }} type="primary" disabled={true}>帮我作图</Button>
                            </div>
                        </div>
                    </> :
                    <>
                        {
                            !isEdit ? <div className={styles.FooterBarLeft}>
                                {
                                    batchMode ?
                                        <Space>
                                            <Button
                                                disabled={selectedRowKeys?.length == 0}
                                                onClick={handleBatchSubmit}
                                                loading={loading}
                                                className={styles.BatchTrigger}>
                                                {items.find(item => item.key == batchMode).label}
                                            </Button>
                                            <span
                                                className={styles.BatchTrigger}
                                                style={{ marginLeft: 24, color: '#006EFF', fontSize: 14, cursor: 'pointer' }}
                                                onClick={handleBatchExit}>取消
                                            </span>
                                        </Space> :
                                        <Dropdown
                                            trigger={['click']}
                                            overlayClassName='BatchMenu'
                                            menu={{ items, onClick: handleBatchClick }}
                                            placement="top">
                                            <Button className={styles.BatchTrigger}>批量操作</Button>
                                        </Dropdown>
                                }
                            </div> : <span></span>
                        }
                        {
                            isEdit ? <div className={styles.FooterBarRight}>
                                <div className={styles.BtnGroup}>
                                    <div className={styles.SubmitBtn}>
                                        <Button style={{ width: 200, height: 36 }} type="primary" onClick={() => setSubmitConfigVisible(true)}>生成</Button>
                                    </div>
                                </div>
                            </div> : !batchMode ? <div className={styles.FooterBarRight}>
                                <div className={styles.TaskInfo}>
                                    {
                                        projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
                                            projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ||
                                            projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
                                            projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
                                            projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ?
                                            <span>{skuNumber}{Text3}</span> :
                                            <span>{skuNumber}{Text3} · {total} 张{Text1}</span>
                                    }
                                </div>
                                <div className={styles.BtnGroup}>
                                    <Button style={{ width: 200, height: 36 }} onClick={onAddMore}>{Text2}</Button>
                                    <div className={styles.SubmitBtn}>
                                        <Button style={{ width: 200, height: 36 }} type="primary" onClick={() => setSubmitConfigVisible(true)}>发起批量生成</Button>
                                    </div>
                                </div>
                            </div> : null
                        }
                    </>
            }
            <PSAIModal
                title='设置生图参数'
                maxWidth={564}
                okText={'确定'}
                open={submitConfigVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: createLoading }}
                onCancel={() => setSubmitConfigVisible(false)}
                onOk={() => handleSubmitConfig()}
            >
                <div className={styles.submitConfigWrap}>
                    {
                        (projectType !== BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH && projectType !== BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) &&
                        <div className={styles.submitConfigItem}>
                            <span>源素材生成结果图数量</span>
                            <p>{
                                Array.from({ length: 4 }).map((_, i) => <span className={handleNumber == i + 1 ? styles.active : ''} onClick={() => setHandleNumber(i + 1)} key={i}>{i + 1}张</span>)
                            }</p>
                        </div>
                    }
                    {
                        projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && <div className={styles.submitConfigItem}>
                            <span>生成图比例
                                <Popover content={<p className={styles.PopoverContent}>
                                    <p><span>上传图比例</span> 按上传图比例生成</p>
                                    <p><span>参考图比例</span> 按已选背景参考图比例</p>
                                </p>}>
                                    <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                                </Popover>
                            </span>
                            <div className={styles.PickerContent}>
                                {
                                    resolutionAlignItems.map(item => (
                                        <div
                                            key={item.value}
                                            className={`${styles.PickerItem} ${resolutionAlign == item.value && styles.actived}`}
                                            onClick={() => setResolutionAlign(item.value)}
                                        >
                                            <span>{item.title}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                    {
                        projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? <div className={styles.submitConfigItem}>
                            <span>生成模式
                                <Popover content={<p className={styles.PopoverContent}>
                                    <p><span>标准模式</span> 生成速度更快</p>
                                    <p><span>高品质模式</span> 生成时间稍长，生成效果更好</p>
                                </p>}>
                                    <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                                </Popover>
                            </span>
                            <div className={styles.PickerContent}>
                                {
                                    modeItems.map(item => (
                                        <div
                                            key={item.value}
                                            className={`${styles.PickerItem} ${item.isLimit && styles.isLimit} ${generateMode == item.value && styles.actived}`}
                                            onClick={() => setGenerateMode(item.value)}
                                        >
                                            <span>{item.title}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div> : (
                            projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ||
                            projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
                            projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ||
                            projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
                            projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
                            projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH) ? null :
                            <>
                                {
                                    projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH &&
                                    <div className={styles.submitConfigItemModel}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>模特表情</div>
                                        <div className={styles.PickerContent} style={{ marginTop: 0 }}>
                                            {
                                                emojiList.map((item) => (
                                                    <Button
                                                        key={item.value}
                                                        className={`${styles.PickerItem} ${emoji == item.value && styles.actived}`}
                                                        onClick={() => setEmoji(item.value)}
                                                    >
                                                        {item.text}
                                                    </Button>
                                                ))
                                            }
                                        </div>
                                    </div>

                                }
                                {
                                    projectType !== BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && <div className={styles.submitConfigItemModel}>
                                        <div>
                                            <p>人像皮肤优化
                                                <Popover content={'开启后人像肤质细节会更精致，但将增加生成时间'}>
                                                    <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                                                </Popover>
                                            </p>
                                        </div>
                                        <div><Switch style={{ marginRight: 8 }} checked={switchChecked} onChange={() => setSwitchChecked(!switchChecked)} />{switchChecked ? '开启' : '关闭'}</div>
                                    </div>
                                }
                                <div className={styles.submitConfigItemModel}>
                                    <div>
                                        <p>光影增强
                                            <Popover content={ContentBox} placement="right">
                                                <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                                            </Popover>
                                        </p>
                                    </div>
                                    <div><Switch
                                        style={{ marginRight: 8 }}
                                        checked={switchChecked2}
                                        onChange={(v) => {
                                            setSwitchChecked2(v)
                                            setRelight(v ? 1.0 : 0.0)
                                        }} />{switchChecked2 ? '开启' : '关闭'}</div>
                                </div>

                                {
                                    relight > 0.0 && <div className={styles.PickerContent}>
                                        {
                                            relightModeItems.map((item) => (
                                                <Button
                                                    key={item.value}
                                                    className={`${styles.PickerItem} ${relightMode == item.value && styles.actived}`}
                                                    onClick={() => setRelightMode(item.value)}
                                                >
                                                    {item.text}
                                                </Button>
                                            ))
                                        }
                                    </div>
                                }
                                {
                                    relight > 0.0 && <div className={styles.SliderWrap}>
                                        <span>更像原图</span>
                                        <Slider className={styles.Slider} max={1.5} min={0.7} value={relight} step={0.1} onChange={value => setRelight(value)} />
                                        <span>更加自然</span>
                                    </div>
                                }
                            </>
                    }

                    <div className={styles.submitConfigBottom}>
                        <p>预计消耗<img style={{ margin: '0 12px', width: '32px', height: '32px' }} src={require('@assets/images/arcbean3.png')} alt="" />
                            <span className={styles.arcbean}>{costInfo.cost}</span></p>
                        <p>{costInfo.desc}</p>
                    </div>
                </div>
            </PSAIModal>
        </div>
    )
})

export default FooterBar
